import { GOOGLE_REVIEWS_URL, googleReviews } from '../data/googleReviews';
import { useLang } from '../i18n';

export default function GoogleReviews() {
  const { t } = useLang();
  return (
    <div className="google-reviews">
      <a className="google-score" href={GOOGLE_REVIEWS_URL} target="_blank" rel="noopener noreferrer" aria-label={t('Ver reseñas de Speak English Now en Google Maps', 'Veure les ressenyes de Speak English Now a Google Maps')}>
        <span>Google</span><strong>4,9</strong><div aria-label={t('5 estrellas', '5 estrelles')}>★★★★★</div><small>{t('Ver todas las reseñas en Google', 'Veure totes les ressenyes a Google')} ↗</small>
      </a>
      <div className="google-review-grid">
        {googleReviews.map(({ name, text, url, avatar }) => (
          <a className="google-review-card" href={url} target="_blank" rel="noopener noreferrer" key={name} aria-label={t(`Leer la reseña de ${name} en Google`, `Llegir la ressenya de ${name} a Google`)}>
            <span className="google-review-stars" aria-label={t('5 estrellas', '5 estrelles')}>★★★★★</span>
            <p lang="es">{text}</p>
            <span className="google-review-source">{t('Texto adaptado · opinión original en Google', 'Text adaptat · opinió original a Google')}</span>
            <span className="google-review-footer"><span className="google-review-person"><img src={avatar} alt="" loading="lazy" /><strong>{name}</strong></span><span>{t('Leer completa', 'Llegir completa')} ↗</span></span>
          </a>
        ))}
      </div>
    </div>
  );
}
